export enum FlexJustifyContentOption {
    FlexStart = 'flex-start',
    Center = 'center',
    FlexEnd = 'flex-end',
    SpaceBetween = 'space-between',
    SpaceAround = 'space-around'
}
